import apiSlice from "../apiSlice";

export const quizApis = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    submitQuiz: builder.mutation({
      query: ({ emailAddress, quizType, answers }) => {
        const answerObj = {};
        answers?.forEach((ans, index) => {
          answerObj[index + 1] = ans;
        });

        return {
          url: "/submit-quiz",
          method: "POST",
          body: {
            emailAddress,
            quizType,
            answers: answerObj,
          },
        };
      },
    }),

    getCertificate: builder.query({
      query: (emailAddress) => ({
        url: "/certification",
        method: "GET",
        params: { emailAddress },
      }),
    }),

    approveStatus: builder.mutation({
      query: (id) => ({
        url: `approveStatus/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["User"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSubmitQuizMutation,
  useGetCertificateQuery,
  useLazyGetCertificateQuery,
  useApproveStatusMutation,
} = quizApis;
